import React from "react";
import { useController } from "react-hook-form";
import FadeInComponent from "./FadeIn";

const Input = (props) => {
  const { placeholder, label, name, error, control, optional } = props;
  const { field } = useController({
    name,
    control,
    defaultValue: ""
  });
  return (
    <FadeInComponent>
      <div className="input-container">
        <label style={{ fontSize: 12, alignSelf: "flex-start", margin: "4px 0" }}>
          {label} {optional && <span style={{ fontSize: "10px" }}>(Optional)</span>}
        </label>
        <input
          name={name}
          autoComplete="off"
          className="input"
          value={field.value}
          onChange={field.onChange}
          placeholder={placeholder}
        />
        {error && <div className="error">{error}</div>}
      </div>
    </FadeInComponent>
  );
};

export default Input;
